import Keycloak from "keycloak-js";
import keycloakConfig  from "../configs/KeycloakConfig";

const _kc = new Keycloak(keycloakConfig);

/**
 * Initializes Keycloak instance and calls the provided callback function if successfully authenticated.
 *
 * @param onAuthenticatedCallback
 */
const initKeycloak = (onAuthenticatedCallback) => {
  // Clean up the URL if it contains Keycloak parameters
  if (window.location.href.includes('?')) {
    const cleanUrl = window.location.href.split('?')[0];
    window.history.replaceState({}, document.title, cleanUrl);
  }

  _kc.init({
    onLoad: 'check-sso',
    silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
    pkceMethod: 'S256',
    checkLoginIframe: false,
  })
    .then((authenticated) => {
      if (!authenticated) {
        _kc.login();
      }
      onAuthenticatedCallback();
    })
    .catch((error) => {
      console.error('Keycloak init error:', error);
    });
};

const doLogin = _kc.login;

const doLogout = _kc.logout;

const getToken = () => _kc.token;

const getTokenParsed = () => _kc.tokenParsed;

const isLoggedIn = () => !!_kc.token;

const updateToken = (successCallback) =>
  _kc.updateToken(5)
    .then(successCallback)
    .catch(doLogin);


const getUsername = () => _kc.tokenParsed?.preferred_username;

const getEmail = () => _kc.tokenParsed?.email;

const getUserId = () => _kc.tokenParsed?.sub;

const getFullName = () => _kc.tokenParsed?.name;

const getFirstName = () => _kc.tokenParsed?.given_name;
const getLastName = () => _kc.tokenParsed?.family_name;

const hasRole = (roles) => roles.some((role) => _kc.hasRealmRole(role));

const activateTotpSetup = () => {
  window.sessionStorage.setItem("profile.activeTab", "#/security");

   return _kc.login({
     action: "CONFIGURE_TOTP",
     redirectUri: `${window.location.origin}${window.location.pathname}${window.location.search}`,
   }).catch((error) => {
     window.sessionStorage.removeItem("profile.activeTab");
     throw error;
   });
};

const activateSmsSetup = () => {
  window.sessionStorage.setItem("profile.activeTab", "#/security");

//    CONFIGURE_SMS must be provided as a Keycloak required action by the realm.
//   return _kc.login({
//     action: "CONFIGURE_SMS",
//     redirectUri: `${window.location.origin}${window.location.pathname}${window.location.search}`,
//   }).catch((error) => {
//     window.sessionStorage.removeItem("profile.activeTab");
//     throw error;
//   });
  };


const getConfiguredSecondFactors = async () => {
  await _kc.updateToken(5);

  const response = await fetch(
    `${keycloakConfig.url}realms/${encodeURIComponent(
      keycloakConfig.realm
    )}/account/credentials`,
    {
      headers: {
        Authorization: `Bearer ${_kc.token}`,
        Accept: "application/json",
      },
    }
  );

  if (!response.ok) {
    throw new Error(
      `Unable to load credentials (${response.status})`
    );
  }

  const credentials = await response.json();
  const otpCredential = credentials.find(
    (credential) => credential.type === "otp"
  );

  return {
    authenticator: Boolean(
      otpCredential?.userCredentialMetadatas?.length
    ),
    //  TODO: This assumes that the Keycloak server is configured to support SMS as a second factor.
    //  If not, this will always return false. 
    sms: credentials.some(
      (credential) =>
        credential.type === "sms" &&
        Boolean(credential.userCredentials?.length)
    ),
  };
};

const UserService = {
  initKeycloak,
  doLogin,
  doLogout,
  isLoggedIn,
  getToken,
  getTokenParsed,
  getUserId,
  updateToken,
  getUsername,
  getFullName,
  getEmail,
  hasRole,
  getFirstName,
  getLastName,
  activateTotpSetup,
  activateSmsSetup,
  getConfiguredSecondFactors,
};

export default UserService;
